import { Star, ShieldCheck } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { BUSINESS } from "../../data/content";
import { Reveal } from "./Reveal";

export const LicenseBanner = () => {
  const navigate = useNavigate();
  return (
    <section data-testid="license-section" className="surface-dark text-white py-16 lg:py-20">
      <div className="mx-auto w-[92%] max-w-[1280px] flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">
        <div>
          <Reveal>
            <div className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.25em] text-fc-cyan">
              <ShieldCheck size={14} /> Licensed &amp; Professional
            </div>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-4 font-display font-semibold tracking-tighter leading-[0.95] text-3xl md:text-5xl max-w-2xl">
              Florida Class A Air Conditioning Contractor
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-4 text-white/80 font-mono text-sm">
              License {BUSINESS.license} · Valid through {BUSINESS.licenseExpiration}
            </p>
          </Reveal>
        </div>
        <Reveal delay={0.15}>
          <button
            data-testid="license-request-btn"
            onClick={() => navigate("/contact")}
            className="bg-white text-fc-ink px-8 py-4 font-semibold hover:bg-fc-ink hover:text-white transition-colors whitespace-nowrap"
          >
            Request Service
          </button>
        </Reveal>
      </div>
    </section>
  );
};

export const Reviews = () => {
  return (
    <section data-testid="reviews-section" className="surface-light py-24 lg:py-32">
      <div className="mx-auto w-[92%] max-w-[1280px] text-center">
        <Reveal>
          <span className="font-mono text-[12px] font-bold uppercase tracking-[0.25em] text-accent">Customer Reviews</span>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-5 font-display font-semibold tracking-tighter leading-[0.95] text-4xl md:text-6xl text-fc-ink">
            What our customers say.
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="mt-12 mx-auto max-w-2xl border border-dashed border-fc-ink/20 bg-white p-12">
            <div className="flex justify-center gap-1 text-fc-orange mb-5">
              {[...Array(5)].map((_, i) => <Star key={i} size={22} fill="currentColor" />)}
            </div>
            <p className="text-fc-ink2">
              Verified customer reviews will appear here from the company’s review sources.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
